module.exports = __webpack_public_path__ + "static/media/Паспорт Модуль Unilight NEMA.1d55ecc0.pdf";